import * as actionTypes from "./actionTypes";
import { updateObject } from "../../util/updateObject";
import {
  initialAltriData,
  initialCreateMenuServiceData,
  initialCreateTempoData,
  initialCurrentMenuService,
  initialCurrentOrigine,
  initialCurrentTempo,
  intialCreateOrigineData,
} from "./helper";

const initialState = {
  altriInstradamento: initialAltriData,
  exportLoading: false,
  createDeleteLoading: false,
  createMenuServiceData: initialCreateMenuServiceData,
  currentMenuService: initialCurrentMenuService,
  createOrigineData: intialCreateOrigineData,
  currentOrigine: initialCurrentOrigine,
  createTempoData: initialCreateTempoData,
  currentTempo: initialCurrentTempo,
};

const setAltriInstradamento = (state, action) => {
  return updateObject(state, {
    altriInstradamento: updateObject(state.altriInstradamento, {
      [action.key]: action.value,
    }),
  });
};

const setExportAltriInstradamentoLoading = (state, action) => {
  return updateObject(state, {
    exportLoading: action.value,
  });
};

const setCreateDeletePianiDiInstradamentoLoading = (state, action) => {
  return updateObject(state, {
    createDeleteLoading: action.value,
  });
};

const setCreateMenuServiceData = (state, action) => {
  return updateObject(state, {
    createMenuServiceData: updateObject(state.createMenuServiceData, {
      [action.key]: action.value,
    }),
  });
};

const setCurrentMenuService = (state, action) => {
  return updateObject(state, {
    currentMenuService: updateObject(state.currentMenuService, {
      [action.key]: action.value,
    }),
  });
};

const setCreateOrigineData = (state, action) => {
  return updateObject(state, {
    createOrigineData: updateObject(state.createOrigineData, {
      [action.key]: action.value,
    }),
  });
};

const setCurrentOrigine = (state, action) => {
  return updateObject(state, {
    currentOrigine: updateObject(state.currentOrigine, {
      [action.key]: action.value,
    }),
  });
};

const setCreateTempoData = (state, action) => {
  return updateObject(state, {
    createTempoData: updateObject(state.createTempoData, {
      [action.key]: action.value,
    }),
  });
};

const setCurrentTempo = (state, action) => {
  return updateObject(state, {
    currentTempo: updateObject(state.currentTempo, {
      [action.key]: action.value,
    }),
  });
};

const altriInstradamentoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALTRI_INSTRADAMENTO_DATA_AND_LOADING:
      return setAltriInstradamento(state, action);
    case actionTypes.EXPORT_ALTRI_INSTRADAMENTO_LOADING:
      return setExportAltriInstradamentoLoading(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_PIANI_DI_INSTRADAMENTO_LOADING:
      return setCreateDeletePianiDiInstradamentoLoading(state, action);
    case actionTypes.GET_CREATE_MENU_SERVICE_DATA:
      return setCreateMenuServiceData(state, action);
    case actionTypes.GET_CURRENT_MENU_SERVICE:
      return setCurrentMenuService(state, action);
    case actionTypes.GET_CREATE_ORIGINE_DATA:
      return setCreateOrigineData(state, action);
    case actionTypes.GET_CURRENT_ORIGINE:
      return setCurrentOrigine(state, action);
    case actionTypes.GET_CREATE_TEMPO_DATA:
      return setCreateTempoData(state, action);
    case actionTypes.GET_CURRENT_TEMPO:
      return setCurrentTempo(state, action);
    default:
      return state;
  }
};

export default altriInstradamentoReducer;
